import { z } from 'zod';
import { SUPPORTED_LANGUAGES } from '../constants';

export const LanguageEnum = z.enum(SUPPORTED_LANGUAGES);

export const UpdateMeInput = z.object({
  nickname: z.string().min(1).max(32).optional(),
  language: LanguageEnum.optional(),
});
export type UpdateMeInput = z.infer<typeof UpdateMeInput>;

// Email changes go through verification (Resend), not a direct PATCH.
export const EmailStartInput = z.object({
  email: z
    .string()
    .email()
    .max(120)
    .transform((v) => v.trim().toLowerCase()),
});
export type EmailStartInput = z.infer<typeof EmailStartInput>;

export const EmailVerifyInput = z.object({
  code: z.string().regex(/^\d{6}$/, '6-digit code'),
});
export type EmailVerifyInput = z.infer<typeof EmailVerifyInput>;

const PIN_RE = /^\d{4,6}$/;

export const SetPinInput = z.object({
  pin: z.string().regex(PIN_RE, 'PIN must be 4-6 digits'),
  /** Required when a PIN already exists (verified before replacing it). */
  currentPin: z.string().regex(PIN_RE).optional(),
});
export type SetPinInput = z.infer<typeof SetPinInput>;

export const BiometricInput = z.object({ enabled: z.boolean() });
export type BiometricInput = z.infer<typeof BiometricInput>;

const FaqQuestion = z.object({
  en: z.string().min(1).max(300),
  ru: z.string().max(300).default(''),
  uk: z.string().max(300).optional(),
  pl: z.string().max(300).optional(),
  es: z.string().max(300).optional(),
  tr: z.string().max(300).optional(),
  el: z.string().max(300).optional(),
  it: z.string().max(300).optional(),
  de: z.string().max(300).optional(),
  pt: z.string().max(300).optional(),
});
const FaqAnswer = z.object({
  en: z.string().min(1).max(4000),
  ru: z.string().max(4000).default(''),
  uk: z.string().max(4000).optional(),
  pl: z.string().max(4000).optional(),
  es: z.string().max(4000).optional(),
  tr: z.string().max(4000).optional(),
  el: z.string().max(4000).optional(),
  it: z.string().max(4000).optional(),
  de: z.string().max(4000).optional(),
  pt: z.string().max(4000).optional(),
});

export const FaqItemsInput = z.object({
  items: z.array(z.object({ q: FaqQuestion, a: FaqAnswer })).max(100),
});
export type FaqItemsInput = z.infer<typeof FaqItemsInput>;

export const NotificationPrefsInput = z.object({
  deposits: z.boolean().optional(),
  transfers: z.boolean().optional(),
  cards: z.boolean().optional(),
  security: z.boolean().optional(),
});
export type NotificationPrefsInput = z.infer<typeof NotificationPrefsInput>;

export const ReauthInput = z.object({
  method: z.enum(['pin', 'biometric']),
  pin: z.string().regex(PIN_RE).optional(),
});
export type ReauthInput = z.infer<typeof ReauthInput>;
